import ReactMarkdown from 'react-markdown';

export function EnrichedText({ content, className = '' }: { content: string; className?: string }) {
  return (
    <div className={`text-sm leading-relaxed text-on-surface-variant ${className}`.trim()}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p className="mb-3 last:mb-0">{children}</p>,
          strong: ({ children }) => <strong className="font-semibold text-on-surface">{children}</strong>,
          em: ({ children }) => <em className="italic text-on-surface">{children}</em>,
          ul: ({ children }) => <ul className="my-3 list-disc space-y-1 pl-5 marker:text-primary">{children}</ul>,
          ol: ({ children }) => <ol className="my-3 list-decimal space-y-1 pl-5 marker:text-primary">{children}</ol>,
          li: ({ children }) => <li>{children}</li>,
          h1: ({ children }) => <h1 className="mb-3 mt-5 text-lg font-bold text-on-surface first:mt-0">{children}</h1>,
          h2: ({ children }) => <h2 className="mb-2 mt-4 text-base font-bold text-on-surface first:mt-0">{children}</h2>,
          h3: ({ children }) => <h3 className="mb-2 mt-4 text-sm font-semibold text-on-surface first:mt-0">{children}</h3>,
          blockquote: ({ children }) => (
            <blockquote className="my-3 border-l-2 border-primary/30 pl-4 italic text-on-surface-variant">{children}</blockquote>
          ),
          code: ({ className: codeClassName, children, ...props }) => {
            const isBlock = Boolean(codeClassName);
            if (isBlock) {
              return (
                <pre className="my-3 overflow-x-auto rounded-xl bg-surface-container px-4 py-3 text-xs text-on-surface">
                  <code {...props}>{children}</code>
                </pre>
              );
            }

            return (
              <code className="rounded bg-surface-container-high px-1.5 py-0.5 text-xs text-primary" {...props}>
                {children}
              </code>
            );
          },
          pre: ({ children }) => <>{children}</>,
          hr: () => <hr className="my-4 border-outline-variant/20" />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
